var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGif(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-712 -554) translate(40 554) translate(672)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M8.329 15.5c1.217 0 2.615-.658 2.615-1.813V12.46c0-.395-.304-.73-.684-.73H8.376c-.266 0-.485.234-.485.517 0 .314.22.547.485.547h1.437v1.023c-.276.284-.847.598-1.484.598-1.246 0-2.169-1.023-2.169-2.421 0-1.408.923-2.421 2.169-2.421.542 0 1.075.243 1.455.648.105.112.238.172.38.172.286 0 .533-.243.533-.547 0-.142-.048-.283-.143-.385C10.05 8.905 9.327 8.5 8.33 8.5 6.493 8.5 5 9.878 5 11.995S6.493 15.5 8.329 15.5zm4.327-.07c.324 0 .58-.274.58-.599V9.138c0-.314-.256-.587-.56-.587-.324 0-.571.273-.571.587v5.693c0 .325.247.598.551.598zM16 4.5c4.142 0 7.5 3.358 7.5 7.5 0 4.142-3.358 7.5-7.5 7.5H8C3.858 19.5.5 16.142.5 12 .5 7.858 3.858 4.5 8 4.5zm-.19 1.31H8.19C4.772 5.81 2 8.582 2 12c0 3.42 2.772 6.191 6.19 6.191h7.62c3.418 0 6.19-2.772 6.19-6.19 0-3.42-2.772-6.191-6.19-6.191zm2.705 2.801c.266 0 .485.233.485.537 0 .294-.219.527-.485.527h-2.796v1.722h2.73c.266 0 .484.233.484.537 0 .294-.218.527-.485.527h-2.73v2.37c0 .325-.256.598-.58.598-.304 0-.551-.273-.551-.598v-5.49c0-.395.304-.73.685-.73z",
    transform: "translate(-712 -554) translate(40 554) translate(672)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGif);
export default __webpack_public_path__ + "static/media/iconGif.a0217210.svg";
export { ForwardRef as ReactComponent };